export class Button {
  text:string;
  value:string;

  constructor(text:string, value:string) {
    this.text = text;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/button.ts